import {
  TextField,
  Box,
  Typography,
  styled,
  RadioGroup,
  Radio,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import FormHelperText from "@mui/joy/FormHelperText";
import ImageUpload from "./ImageUpload";
import { useSelector } from "react-redux";

const CustomTextarea = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #414466",
    borderRadius: "8px",
    color: "white",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
      outline: "none",
    },

    [theme.breakpoints.down("md")]: {
      padding: "7.5px 9px",
    },

    "& .MuiInputBase-input": {
      // maxHeight: "70px",
      [theme.breakpoints.down("md")]: {
        maxHeight: "52px",

        padding: "0px",
      },
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const StyledRadio = styled(Radio)(({ theme }) => ({
  color: "white",
  padding: "0",
  "&.Mui-checked": {
    color: "#343759",
  },
  "&.MuiRadio-root": {
    padding: "0",
  },
}));

const StyledRadioD = styled(Radio)(({ theme }) => ({
  display: "none",
}));

const StyledRadioLable = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "checked",
})(({ theme, checked }) => ({
  gap: "10px",
  alignItems: "center",
  margin: theme.spacing(1),
  padding: "15px 20px",
  backgroundColor: checked ? "#FFCD1F" : "#343759",
  borderRadius: "40px",
  cursor: "pointer",
  fontFamily: "Arial",
  fontStyle: "normal",
  fontWeight: "500",
  fontSize: "17px",
  lineHeight: "17px",
  letterSpacing: "0.02em",

  color: checked ? "black" : "#ffffff",
  [theme.breakpoints.down("md")]: {
    padding: "8px 11px",
    fontSize: "14px",
  },

  //   opacity: "0.6",
  padding: "15px 20px",
  textTransform: "none",

  "& .Mui-checked ": {
    backgroundColor: "#FFCD1F",
    color: "black",
  },

  "& .MuiFormControlLabel-label": {
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
  },
}));

const Step1 = ({ formik, edited }) => {
  const goalCategories = useSelector((state) => state.goalCategories);
  return (
    <>
      <Box className="profile-wrapper">
        <ImageUpload formik={formik} edited={edited} />
      </Box>

      <Box className="title form-control">
        <Typography className="label">Title</Typography>
        <CustomTextarea
          id="outlined-multiline-static"
          rows={5}
          multiline
          placeholder="Describe your goal"
          variant="outlined"
          value={formik.values.title}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          name="title"
        />

        {formik.touched.title && formik.errors.title ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.touched.title && formik.errors.title}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      <Box className="category form-control">
        <Typography className="label">Video Category</Typography>
        <RadioGroup name="category" row>
          {goalCategories.loading ? (
            <CircularProgress sx={{ color: "#ef364e" }} />
          ) : goalCategories.data?.data?.length > 0 ? (
            goalCategories.data.data
              ?.filter((cat) => cat.enable)
              .map((category, index) => (
                <StyledRadioLable
                  control={
                    <StyledRadioD
                      value={category.id}
                      onChange={formik.handleChange}
                      checked={formik.values.category === category.id}
                    />
                  }
                  label={category.name}
                  checked={formik.values.category === category.id}
                  key={category.id}
                  onClick={() => {
                    formik.setFieldValue("category", category.id);
                    formik.setFieldValue("subCategory", null);
                    formik.setFieldValue("childCategory", null);
                    formik.setFieldTouched("category", true);
                  }}
                />
              ))
          ) : null}
        </RadioGroup>
        {formik.touched.category && formik.errors.category ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.touched.category && formik.errors.category}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      {formik.values.category == "6" && (
        <>
          <Box className="category form-control">
            {/* <Typography className="label">Video Category</Typography> */}
            <RadioGroup name="subCategory" row>
              {goalCategories.loading ? (
                <CircularProgress sx={{ color: "#ef364e" }} />
              ) : goalCategories.data?.data?.length > 0 ? (
                goalCategories.data.data
                  ?.filter((cat) => cat.enable)
                  .find((cat) => cat.id == "6")
                  ?.subCategory?.map((category, index) => (
                    <StyledRadioLable
                      control={
                        <StyledRadioD
                          value={category.id}
                          onChange={formik.handleChange}
                          checked={formik.values.subCategory === category.id}
                        />
                      }
                      label={category.name}
                      checked={formik.values.subCategory === category.id}
                      key={category.id}
                      onClick={() => {
                        formik.setFieldValue("subCategory", category.id);
                        formik.setFieldTouched("subCategory", true);
                      }}
                    />
                  ))
              ) : null}
            </RadioGroup>
            {formik.touched.subCategory && formik.errors.subCategory ? (
              <FormHelperText sx={{ color: "red" }}>
                {formik.touched.subCategory && formik.errors.subCategory}
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>
          <Box className="category form-control">
            {/* <Typography className="label">Video Category</Typography> */}
            <RadioGroup name="subCategory" row>
              {goalCategories.loading ? (
                <CircularProgress sx={{ color: "#ef364e" }} />
              ) : goalCategories.data?.data?.length > 0 ? (
                goalCategories.data.data
                  ?.filter((cat) => cat.enable)
                  .find((cat) => cat.id == "6")
                  ?.subCategory?.find(
                    (subc) => subc.id == formik.values.subCategory
                  )
                  ?.childSubCategories?.map((category, index) => (
                    <StyledRadioLable
                      control={
                        <StyledRadioD
                          value={category.id}
                          onChange={formik.handleChange}
                          checked={formik.values.childCategory === category.id}
                        />
                      }
                      label={category.name}
                      checked={formik.values.childCategory === category.id}
                      key={category.id}
                      onClick={() => {
                        formik.setFieldValue("childCategory", category.id);
                        formik.setFieldTouched("childCategory", true);
                      }}
                    />
                  ))
              ) : null}
            </RadioGroup>
            {formik.touched.childCategory && formik.errors.childCategory ? (
              <FormHelperText sx={{ color: "red" }}>
                {formik.touched.childCategory && formik.errors.childCategory}
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>
        </>
      )}

      <Box className="category form-control">
        <Typography className="label">Video From</Typography>
        <RadioGroup name="from_uk" row>
          {[
            { name: "UK", id: 1 },
            { name: "International", id: 0 },
          ].map((category) => (
            <StyledRadioLable
              control={
                <StyledRadio
                  value={category.id}
                  onChange={(e) => {
                    if (e.target.checked)
                      formik.setFieldValue("from_uk", category.id);
                    formik.setFieldTouched("from_uk", true);
                  }}
                  checked={formik.values.from_uk === category.id}
                />
              }
              label={category.name}
              checked={formik.values.from_uk === category.id}
              key={category.id}
              onClick={() => {
                formik.setFieldValue("from_uk", category.id);
                formik.setFieldTouched("from_uk", true);
              }}
            />
          ))}
        </RadioGroup>
        {formik.touched.from_uk && formik.errors.from_uk ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.touched.from_uk && formik.errors.from_uk}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      <Box className="category form-control">
        <Typography className="label">City/Town</Typography>
        <CustomTextarea
          variant="outlined"
          name="region"
          // select
          value={formik.values.region}
          onChange={formik.handleChange}
          placeholder="Select Region"
          onBlur={formik.handleBlur}
        ></CustomTextarea>
        {formik.touched.region && formik.errors.region ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.touched.region && formik.errors.region}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      <Box className="category form-control">
        <Typography className="label">Name of Club</Typography>
        <CustomTextarea
          variant="outlined"
          name="club"
          value={formik.values.club}
          onChange={formik.handleChange}
          placeholder="Enter Club Name"
          onBlur={formik.handleBlur}
        />
        {formik.touched.club && formik.errors.club ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.errors.club}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>

      <Box className="category form-control">
        <Typography className="label">Name of Challenger</Typography>
        <CustomTextarea
          variant="outlined"
          name="goal_scorer"
          value={formik.values.goal_scorer}
          onChange={formik.handleChange}
          placeholder="Enter Challenger Name"
          onBlur={formik.handleBlur}
        />
        {formik.touched.goal_scorer && formik.errors.goal_scorer ? (
          <FormHelperText sx={{ color: "red" }}>
            {formik.errors.goal_scorer}
          </FormHelperText>
        ) : (
          ""
        )}
      </Box>
    </>
  );
};

export default Step1;
